<template>
  <div>
    <h1>Onboarding Users</h1>
    <br>

    <v-card>
      <v-card-title class="card-title">
        <span class="headline white--text text-uppercase">Search</span>
      </v-card-title>

      <v-card-text>
        <search-items
          ref="searchUsersComponent"
          class="search"
          :dark="true"
          placeholder="Search users"
          :select-item="selectUser"
          :get-items="searchUsers"
          :type="'users'"
          :search-length="2"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SearchItems } from '@/components/shared';

export default {
  name: 'OnboardingUsers',
  components: {
    'search-items': SearchItems,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions(['searchUsers']),
    selectUser(item) {
      this.$router.push({
        path: `/users/onboarding-users/${item.id}`,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/onboardingUsers/Users.vue